import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper, Box, Typography, Grid } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { usePortalFramework } from "../../PortalFramework";
// import "../../styles/styles.css";
import { ChangePasswordForm } from "../../components/changePassword/ChangePasswordForm";
const Container = styled("div")(({ theme }) => ({
    [theme.breakpoints.down("sm")]: {
        width: 300,
    },
    [theme.breakpoints.up("sm")]: {
        width: 350,
    },
    [theme.breakpoints.up("lg")]: {
        width: 400,
    },
}));
export const ChangePassword = (props) => {
    const portalFramework = usePortalFramework();
    const theme = useTheme();
    return (_jsxs(Grid, { container: true, justifyContent: "center", alignItems: "center", style: { minHeight: "100vh" }, children: [_jsx(Box, { sx: theme.portalFramework.pages.login.backgroundContainer.sx }), _jsx(Container, { children: _jsxs(Paper, { elevation: 3, sx: { padding: theme.spacing(2) }, children: [_jsxs(Grid, { container: true, justifyContent: "center", alignItems: "center", spacing: 4, style: { paddingBottom: "1rem" }, children: [_jsx(Grid, { item: true, children: _jsx(Box, { sx: {
                                            paddingTop: "1rem",
                                        }, children: _jsx("img", { style: { maxWidth: "100%", maxHeight: "20rem" }, src: portalFramework.settings.logoUrl, alt: "Logo" }) }) }), _jsx(Grid, { item: true, children: _jsx(Typography, { variant: "h4", align: "center", children: "Change Password" }) })] }), _jsx(ChangePasswordForm, {})] }) })] }));
};
